import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";

const BankAccountAndTaxNumbers = () => {
  const { profile, bankAccount, loading } = useContext(ResourceContext);

  if (loading) {
    return <LoadingAnimation />;
  }
  const isPropDefined = (prop) => prop && prop !== "";

  const styles = {
    listStyle: {
      display: "block",
      listStyleType: "none",
      marginBottom: 5,
      paddingLeft: 0,
      flexWrap: "wrap",
    },
    itemStyle: {
      marginRight: "unset",
      fontSize: 12,
    },
  };
  const {
    taxNumber,
    vatId
  } = profile;

  const {
    iban
  } = bankAccount ?? {};

  return (
    <ul style={styles.listStyle}>
      {isPropDefined(iban) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            IBAN: {iban}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(vatId) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            USt.-ID: {vatId}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(taxNumber) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            Steuernummer: {taxNumber}
          </li>
      ) : (
          <br />
      )}
    </ul>
  );
};

export default BankAccountAndTaxNumbers;
